// extracted by mini-css-extract-plugin
module.exports = {"About":"about-module--About--3r6ms chapter-module--Body--1iQV0","h1":"about-module--h1--2zlzQ chapter-module--Title--3-a2u"};